module.exports = __webpack_public_path__ + "static/image/STANDARD.svg?43a68f172cc1cca9cfbda0514f737c24";